import { ColumnTable, Button } from '@octano/global-ui';

import { useTranslation } from 'react-i18next';
import { useMemo } from 'react';
import { TranslationsKeys } from '../../../../locales/translations';

const dictPrefix = 'table';

export const useColumns = ({
  onPressUpload,
}: {
  onPressUpload: () => void;
}): ColumnTable[] => {
  const { t } = useTranslation(
    TranslationsKeys.TUTOR_MANAGEMENT_TUTOR_ASSIGNMENT,
  );

  const columns = useMemo(() => {
    const items: ColumnTable[] = [
      {
        columnName: 'template',
        headerText: t(`${dictPrefix}.template`),
        tdClassName: 'text-left',
        thClassName: 'text-left',
        cellFormat: ({ value }) => value ?? '-',
      },
      {
        columnName: 'id',
        headerText: t(`${dictPrefix}.action`),
        tdClassName: 'text-center',
        thClassName: 'text-center',
        width: 150,
        cellFormat: () => (
          <>
            <Button
              text={t(`${dictPrefix}.upload`)}
              icon="upload"
              size="sm"
              onClick={onPressUpload}
            />
          </>
        ),
      },
    ];

    return items;
  }, [t, onPressUpload]);

  return columns;
};
